import { inject, Injectable } from "@angular/core";

import { StorageService } from "@hermes/core-app-core";

import {
    DEFAULT_EXPIRATION_TIME_IN_MINUTES,
    DEFAULT_VENDOR_ID_KEY,
} from "../constants/vendor-tracking.constants";

@Injectable({ providedIn: "root" })
export class VendorTrackingService {
    private storage = inject(StorageService);

    public getVendorId(): string | undefined {
        return this.storage.getLocalStorageItem(DEFAULT_VENDOR_ID_KEY);
    }

    public cleanVendorId(): void {
        this.storage.removeLocalStorageItem(DEFAULT_VENDOR_ID_KEY);
    }

    public saveVendorId(vendorId: string): void {
        this.storage.setLocalStorageItem(
            DEFAULT_VENDOR_ID_KEY,
            vendorId,
            DEFAULT_EXPIRATION_TIME_IN_MINUTES,
        );
    }
}
